// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Us","firstSessionModal_header":"Vs","firstSessionModal_title":"Ws","firstSessionModal_header_tex":"Xs","firstSessionModal_video":"Ys","firstSessionModal_videoContent":"Zs","firstSessionModal_FAQ":"at","firstSessionModal_FAQMargin":"bt","firstSessionModal_FAQTitle":"ct","firstSessionModal_buttonContainer":"et","firstSessionModal_buttonText":"ft","firstSessionModal_SMSBtn_mob":"gt"};
    if(module.hot) {
      // 1714422952847
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  